module.exports = __webpack_public_path__ + "img/1c.4efa615b.svg";